import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import "react-table/react-table.css";
import couterpart from 'counterpart';

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import WorkOrderDataService from '../services/WorkOrderDataService';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import AuthenticationService from '../services/AuthenticationService';

class LayerTwo extends Component {
  constructor () {
    super();
    this.state = {
      count: 0,
      status: 0
    };
  }

  componentDidMount () {
    let req = {
      status: this.props.info.status, 
      statusList: this.props.info.statusList,
      assigned: this.props.info.assigned >= 0? this.props.info.assigned: -1, 
      semi: this.props.info.semi >=0? this.props.info.semi: -1
    };

    WorkOrderDataService.countForProduction(req).then(data => {
      console.log('Count by status', data)
      this.setState({ 
          status: this.props.info.status,
          count:  data
      });
    });
    this.refreshMe();
  }

  componentWillUnmount(){
    clearInterval(this.state.intervalId);
  }

  reloadData(){
    let req = {
      status: this.props.info.status, 
      statusList: this.props.info.statusList,
      assigned: this.props.info.assigned >= 0? this.props.info.assigned: -1, 
      semi: this.props.info.semi >=0? this.props.info.semi: -1
    };

    WorkOrderDataService.countForProduction(req).then(data => {
      console.log('Count by status', data)
      this.setState({ 
          status: this.props.info.status,
          count:  data
      });
    });
  }

  refreshMe(){
    if (this.props.info === undefined){
      return;
    }
    let intervalId = setInterval(this.reloadData.bind(this), 30000);
    // store intervalId in the state so it can be accessed later:
    this.setState({intervalId: intervalId});
  }

  viewDetails() {
    WorkOrderUtil.removeItem('prod.fromDate')
    WorkOrderUtil.removeItem('wo.fromDate')
    if (AuthenticationService.isDesigner()){
      WorkOrderUtil.saveItem('wo.woStatus', this.state.status);
      this.props.history.push("/workOrders?status=" + this.state.status);
      return;
    }

    if (AuthenticationService.isAdmin() || AuthenticationService.isService()){
      WorkOrderUtil.saveItem('prod.woStatus', this.state.status);
      this.props.history.push("/products?status=" + this.state.status);
      return;
    }

    if (AuthenticationService.isSupervisor()){
      WorkOrderUtil.saveItem('superv.workerName', '');

      if (this.props.info.statusList === undefined || this.props.info.statusList === null){
        WorkOrderUtil.saveItem('superv.selectedWoStatusList', JSON.stringify([
          {id: this.state.status, name: WorkOrderUtil.getStatusDescription(this.props.allStatus, this.state.status)}
        ]));
      } else {
        let selectedStatusList = [];
        for(let  i=0 ;i<this.props.info.statusList.length; i++){
          selectedStatusList.push({
            id: this.props.info.statusList[i], name: WorkOrderUtil.getStatusDescription(this.props.allStatus, this.props.info.statusList[i])
          });
        }
        WorkOrderUtil.saveItem('superv.selectedWoStatusList', JSON.stringify(selectedStatusList));
      }
      WorkOrderUtil.saveItem('superv.semi', this.props.info.semi >=0? this.props.info.semi: -1);
      
      if (this.props.info.assigned >= 0){
        let notAssigned = this.props.info.assigned > 0? 0 : 1;
        WorkOrderUtil.saveItem('superv.notAssigned', notAssigned);
      } else {
        WorkOrderUtil.saveItem('superv.notAssigned', -1);
      }
      
      this.props.history.push("/super?status=" + this.state.status);
      return;
    }    
  }

  render() {
    if (this.props.info === undefined){
      return (<></>);
    }
    return (
      <Card className={ this.props.styleInfo }  style={{ width: '12rem' }} onClick={this.viewDetails.bind(this)}>
        {/* <Card.Img variant="top" src="holder.js/100px180" /> */}
        <Card.Body>
          <Card.Title> { this.props.title? this.props.title : WorkOrderUtil.getStatusDescription(this.props.allStatus, this.state.status) }</Card.Title>
          <Card.Text>
            { this.state.count }
          </Card.Text>
          {/* <Button className="myButton" onClick={this.viewDetails.bind(this)}>{ couterpart.translate('wo_goto_details') }</Button> */}
        </Card.Body>
      </Card>  
    )
  }
}

export default withRouter(LayerTwo);